import { AfterViewInit, Component, ComponentRef, ElementRef, EventEmitter, HostBinding, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { Section, SectionData } from '../../editor-container/editor-model';
import { ContentElement, CategoryRendererComponent, DynamicRendererComponent, GridCell, GridRendererComponent, RowRendererComponent, BannerRendererComponent, BlogListRendererComponent, TestimonialRendererComponent, HeadFootEnum, RowCell, RendererDataInterFace, RenderSectionDirective, ProductRendererComponent, SliderRendererComponent, HeroImageRendererComponent } from '@urbannex/storethemes';
import { CellEditorStoreService } from '../cell-editor-store.service';
import { Subject, Subscription } from 'rxjs';
import { PreviewEditStoreService } from '../../services/preview-edit-store.service';
import { LayoutEditorService } from '../layout-editor/layout-editor.service';
import { take, takeUntil, tap } from 'rxjs/operators';
import { RenderCellDirective } from './render-cell.directive';
import { IframeCommunicationService } from '../../services/iframe-communication.service';
import { ThemeEditorStoreService } from '../theme-editor/theme-editor-store.service';

@Component({
  selector: 'kve-shared-preview-editor',
  templateUrl: './shared-preview-editor.component.html',
  styleUrls: ['./shared-preview-editor.component.scss']
})
export class SharedPreviewEditorComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {
  @Input() section: Section
  @Input() cellId: string
  @Input() selectedCell: GridCell
  @Input() tabbed: boolean
  @Input() layoutClass: string;
  @Input() selectedTabTitle: string;
  @Input() posChange: string;
  @Input() size: string;

  previousSize: string;

  fillClass: string;
  fillColor: string;
  imgSrc: string
  bgImgSrc: string;
  imgSrc$: Subscription;
  contentElements$: Subscription;
  selectorPosChange$: Subscription;
  posChanged: string;
  cellBgColor$: Subscription;

  contentElements: ContentElement[]

  headerText: string;
  bannerText: string;
  footerText: string;

  rendererType: string;
  activeSelector$: Subscription;
  activeSelector: ContentElement;
  headerFooterOption$: Subscription;

  layoutClass$: Subscription;
  fillClass$: Subscription;
  fillColor$: Subscription;
  themeClass$: Subscription;
  themeClass: string;
  previewBgColor: string;
  headerFooterOption: HeadFootEnum;

  headerTxtClr: string;
  headerTxtClr$: Subscription;
  footerTxtCl: string;
  footerTxtClr$: Subscription;
  txtClr: string;
  txtClr$: Subscription;
  heightCls$: Subscription;
  heightCls: string;

  hdrFntSizeClass: string;
  hdrFntSizeClass$: Subscription;

  hdrFontFam: string;
  hdrFontFam$: Subscription;

  ftrFntSizeClass$: Subscription
  ftrFntSizeClass: string
  txtFntSizeClass$: Subscription
  txtFntSizeClass: string

  // Container variables
  hdrContBgClr$: Subscription;
  ftrContBgClr$: Subscription;
  txtContBgClr$: Subscription;
  hdrContBgClr: string;
  ftrContBgClr: string;
  txtContBgClr: string;

  hdrContLayoutClass$: Subscription;
  ftrContLayoutClass$: Subscription;
  txtContLayoutClass$: Subscription;
  hdrContLayoutClass: string;
  ftrContLayoutClass: string;
  txtContLayoutClass: string;

  // Parent Subscriptions
  hdrParBgColor$: Subscription;
  hdrParBgColor: string;
  ftrParBgColor$: Subscription;
  ftrParBgColor: string;
  txtParBgColor$: Subscription;
  txtParBgColor: string;

  // Borders
  hdrBorderWdtCls$: Subscription;
  hdrBorderWdtCls: string;
  ftrBorderWdtCls$: Subscription;
  ftrBorderWdtCls: string;
  txtBorderWdtCls$: Subscription;
  txtBorderWdtCls: string;

  hdrBorderRdsCls$: Subscription;
  hdrBorderRdsCls: string;
  ftrBorderRdsCls$: Subscription;
  ftrBorderRdsCls: string;
  txtBorderRdsCls$: Subscription;
  txtBorderRdsCls: string;

  hdrBorderColr$: Subscription;
  hdrBorderColr: string;
  ftrBorderColr$: Subscription;
  ftrBorderColr: string;
  txtBorderColr$: Subscription;
  txtBorderColr: string;

  // Padding
  hdrPadCust$: Subscription;
  hdrPadCust: string;
  ftrPadCust$: Subscription;
  ftrPadCust: string;
  txtPadCust$: Subscription;
  txtPadCust: string;

  // Alignment
  hdrAlign$: Subscription;
  ftrAlign$: Subscription;
  txtAlign$: Subscription;
  hdrAlign: string;
  ftrAlign: string;
  txtAlign: string;

  contentWidth$: Subscription;
  cellVerticalAlign$: Subscription;
  cellHorizontalAlign$: Subscription;

  private destroy$: Subject<void> = new Subject<void>()

  selectedCell$: Subscription;
  cellTextColor$: Subscription;
  contentElement$: Subscription;

  rendererComponent: DynamicRendererComponent

  kveThemeClass: string;

  // SelectedCell
  /* readonly _selectedCell$ = this.cellEditorStoreService.selectedCell$.pipe(takeUntil(this.destroy$),tap(selectedCell => {
    console.log(selectedCell)
    if(selectedCell){
      this.selectedCell = selectedCell;
      this.fillClass = selectedCell.fillClass;
      this.contentElements = this.selectedCell.contentElements;
    }

  })).subscribe(selectedCell => console.log(selectedCell)); */





  // @HostBinding("style.--bgImgSrc")
  @ViewChild('fillLayer', { read: HTMLElement }) fillLayer: HTMLElement;
  @ViewChild(RenderCellDirective, { static: false }) kveRenderCell!: RenderCellDirective;
  @ViewChild('previewHost', { read: TemplateRef }) previewHost: TemplateRef<any>;
  @Output() responsiveView = new EventEmitter<any>();

  constructor(
    private cellEditorStoreService: CellEditorStoreService,
    private themeEditorStoreService: ThemeEditorStoreService,
    private previewEditStoreService: PreviewEditStoreService) { }

  ngOnInit(): void {
    /* this.selectedCell$ = this.cellEditorStoreService.selectedCell$.pipe(takeUntil(this.destroy$)).subscribe(selectedCell => {
      if (selectedCell) {
        console.log("Selected Cell Changed in Preview Editor", selectedCell);
        this.selectedCell = selectedCell;
        console.log({ selectedCell: selectedCell, sectionDataSelectedCell: this.section.sectionData.selectedCell })
        this.section = this.updateSection(selectedCell);
        console.log(this.section);
        this.loadComponent(this.rendererComponent.component);
      }
    }) */


    this.themeClass$ = this.cellEditorStoreService.theme$.subscribe((_themeClass: string) => {
      if (_themeClass != null && _themeClass != undefined) {
        this.themeClass = _themeClass;
      } else {
        this.themeClass = "cell-theme-default"
      }
    })
    this.layoutClass$ = this.cellEditorStoreService.layoutClass$.subscribe((_layoutClass: string) => {
      this.layoutClass = _layoutClass ? _layoutClass : "layout-class-1";
      console.log({ layoutClass: this.layoutClass });
      this.selectedCell.layoutClass = this.layoutClass;
      // this.refreshPreview();
    })
    this.fillClass$ = this.cellEditorStoreService.fillClass$.subscribe((_fillClass: string) => {
      this.fillClass = _fillClass;
      console.log("loading fill class")
      // this.selectedCell.fillClass = this.fillClass;
      // this.refreshPreview();
    })
    this.fillColor$ = this.cellEditorStoreService.fillColor$.subscribe((_fillColor: string) => {
      this.fillColor = _fillColor;
      // this.selectedCell.fillColor = this.fillColor;
      if (this.fillClass == undefined) {
        this.selectedCell.bgColor = this.fillColor;
      }
    })
    // this.imgSrc$ = this.cellEditorStoreService.imgSrc$.subscribe((_imgSrc: string) => {
    // if (_imgSrc != null && _imgSrc != undefined && _imgSrc != "") {
    // console.log("Image Source = " + _imgSrc);
    // this.imgSrc = _imgSrc;
    // if (this.selectedCell != undefined) {
    // this.selectedCell.imgSrc = this.imgSrc;
    // }
    // console.log(this.imgSrc);
    // this.bgImgSrc = "url(" + _imgSrc + ")";
    /* this.cellEditorStoreService.selectedCell$.subscribe((_selectedCell: GridCell | RowCell) => {
      this.selectedCell = _selectedCell;
      console.log(this.selectedCell);
      this.loadComponent(this.rendererComponent.component);
    }) */
    // }

    // })
    /* this.contentElement$ = this.cellEditorStoreService.contentElements$.subscribe(contentElements => {
      console.log(contentElements);
      this.selectedCell.contentElements = contentElements;
      this.refreshPreview();
    }) */
    this.selectorPosChange$ = this.cellEditorStoreService.selectorPosChange$.subscribe(thing => {
      console.log(thing);
      this.refreshPreview();
    })
    this.headerFooterOption$ = this.cellEditorStoreService.headerFooterOption$.subscribe((_headerFooterOption: HeadFootEnum) => {
      this.headerFooterOption = _headerFooterOption;
    })

    this.cellEditorStoreService.fillClass$.pipe(takeUntil(this.destroy$)).subscribe((_fillClass: string) => {
      if (_fillClass != null && _fillClass != undefined) {
        this.fillClass = _fillClass
      }
    })
    this.cellEditorStoreService.fillColor$.pipe(takeUntil(this.destroy$)).subscribe((_fillColor: string) => {
      if (_fillColor != null && _fillColor != undefined) {
        this.fillColor = _fillColor
      }
    })
    this.headerTxtClr$ = this.cellEditorStoreService.headerTxtClr$.pipe(takeUntil(this.destroy$)).subscribe((color: string) => {
      if (color != null && color != undefined) {
        this.headerTxtClr = color;
      }
    })
    this.footerTxtClr$ = this.cellEditorStoreService.footerTxtClr$.pipe(takeUntil(this.destroy$)).subscribe((color: string) => {
      if (color != null && color != undefined) {
        this.footerTxtCl = color;
      }
    })
    this.txtClr$ = this.cellEditorStoreService.txtClr$.pipe(takeUntil(this.destroy$)).subscribe((color: string) => {
      if (color != null && color != undefined) {
        this.txtClr = color;
      }
    })
    this.heightCls$ = this.cellEditorStoreService.heightClass$.pipe(takeUntil(this.destroy$)).subscribe((hghtCls: string) => {
      if (hghtCls != null && hghtCls != undefined) {
        console.log(hghtCls)
        this.heightCls = hghtCls;
        this.refreshPreview();
      }
    })

    this.hdrFntSizeClass$ = this.cellEditorStoreService.hdrFontSize$.pipe(takeUntil(this.destroy$)).subscribe((fontClass: string) => {
      if (fontClass != null && fontClass != undefined) {
        this.hdrFntSizeClass = fontClass;
      }
    })
    this.hdrFontFam$ = this.cellEditorStoreService.hdrFontFam$.pipe(takeUntil(this.destroy$)).subscribe((fontFam: string) => {
      if (fontFam != null && fontFam != undefined) {
        this.hdrFontFam = fontFam;
      }
    })

    this.ftrFntSizeClass$ = this.cellEditorStoreService.ftrFontSizeClass$.subscribe((fontClass: string) => {
      this.ftrFntSizeClass = fontClass;
    })
    this.txtFntSizeClass$ = this.cellEditorStoreService.textFntSze$.subscribe((fontClass: string) => {
      if (fontClass != null && fontClass != undefined) {
        this.txtFntSizeClass = fontClass;
      }
    })
    // Container BG Subscriptions
    this.hdrContBgClr$ = this.cellEditorStoreService.hdrContBgClr$.subscribe((color: string) => {
      if (color != null && color != undefined) {
        this.hdrContBgClr = color;
      }
    })
    this.ftrContBgClr$ = this.cellEditorStoreService.ftrContBgClr$.subscribe((color: string) => {
      if (color != null && color != undefined) {
        this.ftrContBgClr = color;
      }
    })
    this.txtContBgClr$ = this.cellEditorStoreService.txtContBgClr$.subscribe((color: string) => {
      if (color != null && color != undefined) {
        this.txtContBgClr = color;
      }
    })
    this.hdrContLayoutClass$ = this.cellEditorStoreService.hdrContLayoutClass$.subscribe((layoutClass: string) => {
      if (layoutClass != null && layoutClass != undefined) {
        this.hdrContLayoutClass = layoutClass;
      }
    })
    this.ftrContLayoutClass$ = this.cellEditorStoreService.ftrContLayoutClass$.subscribe((layoutClass: string) => {
      if (layoutClass != null && layoutClass != undefined) {
        this.ftrContLayoutClass = layoutClass;
      }
    })
    this.txtContLayoutClass$ = this.cellEditorStoreService.txtContLayoutClass$.subscribe((layoutClass: string) => {
      if (layoutClass != null && layoutClass != undefined) {
        this.txtContLayoutClass = layoutClass;
      }
    })
    this.activeSelector$ = this.cellEditorStoreService.activeSelector$.subscribe((selectedContent: any) => {
      console.log(selectedContent, this.selectedCell)
      this.activeSelector = { ...selectedContent };
      // Update the selectedCell content elements
      if (this.selectedCell) {
        console.log("Selected Cell Changed in Preview Editor", this.selectedCell);
        // this.selectedCell = selectedCell;
        // console.log({ selectedCell: selectedCell, sectionDataSelectedCell: this.section.sectionData.selectedCell })
        this.section = this.updateSection(this.selectedCell);
        console.log(this.section);
        this.loadComponent(this.rendererComponent.component);
      }
      /* this.cellEditorStoreService.selectedCell$.pipe(take(1)).subscribe(selectedCell => {
        if (selectedCell) {
          console.log("Selected Cell Changed in Preview Editor", selectedCell);
          this.selectedCell = selectedCell;
          console.log({ selectedCell: selectedCell, sectionDataSelectedCell: this.section.sectionData.selectedCell })
          this.section = this.updateSection(selectedCell);
          console.log(this.section);
          this.loadComponent(this.rendererComponent.component);
        }
      }) */
      // this.section = this.updateSection(selectedCell);
      // this.loadComponent(this.rendererComponent.component);
    })

    /* this.hdrParBgColor$ = this.cellEditorStoreService.hdrParBgColor$.subscribe((color: string) => {
      if (color != null && color != undefined) {
        this.hdrParBgColor = color;
      }
    })
    this.ftrParBgColor$ = this.cellEditorStoreService.ftrParBgColor$.subscribe((color: string) => {
      if (color != null && color != undefined) {
        this.ftrParBgColor = color;
      }
    }) */
    /* this.txtParBgColor$ = this.cellEditorStoreService.txtParBgColor$.subscribe((color: string) => {
      if (color != null && color != undefined) {
        this.txtParBgColor = color;
      }
    })

    this.hdrBorderWdtCls$ = this.cellEditorStoreService.hdrBorderWdtCls$.subscribe((widthCls: string) => {
      this.hdrBorderWdtCls = widthCls ? widthCls : '';
    })
    this.ftrBorderWdtCls$ = this.cellEditorStoreService.ftrBorderWdtCls$.subscribe((widthCls: string) => {
      this.ftrBorderWdtCls = widthCls ? widthCls : '';
    })
    this.txtBorderWdtCls$ = this.cellEditorStoreService.txtBorderWdtCls$.subscribe((widthCls: string) => {
      this.txtBorderWdtCls = widthCls ? widthCls : '';
    })

    this.hdrBorderRdsCls$ = this.cellEditorStoreService.hdrBorderRdsCls$.subscribe((borderCls: string) => {
      this.hdrBorderRdsCls = borderCls ? borderCls : ''
    }) */
    /* this.ftrBorderRdsCls$ = this.cellEditorStoreService.ftrBorderRdsCls$.subscribe((borderCls: string) => {
      this.ftrBorderRdsCls = borderCls ? borderCls : ''
    })
    this.txtBorderRdsCls$ = this.cellEditorStoreService.txtBorderRdsCls$.subscribe((borderCls: string) => {
      this.txtBorderRdsCls = borderCls ? borderCls : ''
    })
    this.hdrBorderColr$ = this.cellEditorStoreService.hdrBorderColr$.subscribe((color: string) => {
      this.hdrBorderColr = color ? color : ''
    })

    this.ftrBorderColr$ = this.cellEditorStoreService.ftrBorderColr$.subscribe((color: string) => {
      this.ftrBorderColr = color ? color : ''
    })
    this.txtBorderColr$ = this.cellEditorStoreService.txtBorderColr$.subscribe((color: string) => {
      this.txtBorderColr = color ? color : ''
    })
    this.hdrPadCust$ = this.cellEditorStoreService.hdrPadCust$.subscribe((padding: string) => {
      this.hdrPadCust = padding;
    })
    this.ftrPadCust$ = this.cellEditorStoreService.ftrPadCust$.subscribe((padding: string) => {
      this.ftrPadCust = padding;
    })
    this.txtPadCust$ = this.cellEditorStoreService.txtPadCust$.subscribe((padding: string) => {
      this.txtPadCust = padding;
    }) */
    // Alignment
    /* this.hdrAlign$ = this.cellEditorStoreService.hdrAlign$.subscribe((alignClass: string) => {
      this.hdrAlign = alignClass;
    })
    this.ftrAlign$ = this.cellEditorStoreService.ftrAlign$.subscribe((alignClass: string) => {
      this.ftrAlign = alignClass;
    })
    this.txtAlign$ = this.cellEditorStoreService.txtAlign$.subscribe((alignClass: string) => {
      this.txtAlign = alignClass;
    })
    this.contentWidth$ = this.cellEditorStoreService.contentWidth$.subscribe((width: string) => {
      if (width != undefined) {
        this.selectedCell.contentWidth = width;
      }
    })
    this.cellTextColor$ = this.cellEditorStoreService.cellTextColor$.subscribe((color: string) => {
      if (color != undefined) {
        this.selectedCell.color = color;
      }
    })

    this.cellVerticalAlign$ = this.cellEditorStoreService.cellVerticalAlign$.subscribe((position: string) => {
      if (position != undefined) {
        this.selectedCell.cellVerticalAlign = position;
      }
    })
    this.cellHorizontalAlign$ = this.cellEditorStoreService.cellHorizontalAlign$.subscribe((position: string) => {
      if (position != undefined) {
        this.selectedCell.cellHorizontalAlign = position;
      }
    })
    this.cellBgColor$ = this.cellEditorStoreService.cellBgColor$.subscribe((color: string) => {
      if (color != undefined) {
        console.log(color)
        this.selectedCell.bgColor = color;
        this.refreshPreview();
      }
    }) */

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["section"]) {
      console.log(this.section);
      if (this.section != undefined) {
        // Ensure that the section data is marked as preview
        this.section.sectionData.isPreview = true;
        // Determine renderer type
        this.rendererType = this.section.rendererType ? this.section.rendererType : "testimonials";
        this.resolveRenderer(this.rendererType);
      }
    }
    if (changes["selectedCell"]) {
      console.log("Selected Cell Changed in Preview Editor", this.selectedCell);
      if (this.selectedCell != undefined && this.rendererType != undefined) {
        // Update the section
        // First update the section data

        // Then update the section
        console.log({ selectedCell: this.selectedCell, sectionDataSelectedCell: this.section.sectionData.selectedCell });
        // this.section.sectionData.selectedCell = this.selectedCell;
        this.contentElements = this.selectedCell.contentElements;
        this.fillClass = this.selectedCell.fillClass;
        this.fillColor = this.selectedCell.fillColor;
        // Update store
        // this.cellEditorStoreService.updateSelectedCell({ ...this.selectedCell });
        this.updateSection(this.selectedCell);
        this.loadComponent(this.rendererComponent.component);
      }
    }
    if (changes["fillColor1"]) {
      console.log(this.fillColor);
    }
    if (changes["size"]) {
      if (this.previousSize != undefined && this.previousSize != 'default' && this.size == 'default') {
        if (this.rendererComponent != undefined) {
          setTimeout(() => {
            this.loadComponent(this.rendererComponent.component);
          }, 100)

        }
        // this.refreshPreview()
      }
      this.previousSize = this.size;
    }
    if (changes["cellId"]) {
      console.log({ "TrackCellId": this.cellId });
    }
  }

  resolveRenderer(rendererType: string): void {
    console.log(this.rendererType, this.section.sectionData);
    switch (this.rendererType) {
      case "grid":
      case "RendererType.GRID":
      case "GRID":
        this.rendererComponent = new DynamicRendererComponent(GridRendererComponent, this.section.sectionData);
        break;
      case "row":
        this.rendererComponent = new DynamicRendererComponent(RowRendererComponent, this.section.sectionData);
        break;
      case "RendererType.BANNER":
      case "BANNER":
      case "banner":
        this.rendererComponent = new DynamicRendererComponent(BannerRendererComponent, this.section.sectionData);
        break;
      case "bloglist":
        this.rendererComponent = new DynamicRendererComponent(BlogListRendererComponent, this.section.sectionData);
        break;
      case "product":
        this.rendererComponent = new DynamicRendererComponent(ProductRendererComponent, this.section.sectionData);
        break;
      case "slider":
        this.section.sectionData.isPreview = true;
        this.rendererComponent = new DynamicRendererComponent(SliderRendererComponent, this.section.sectionData);
        break
      case "hero-image":
        this.rendererComponent = new DynamicRendererComponent(HeroImageRendererComponent, this.section.sectionData);
        break
      /* case "slider":
        this.section = new KwikstoreSection<Slider>();
        this.section.heading = this.sectionData.heading;
        this.section.sliderOptions = this.sectionData;
        this.rendererComponent = new DynamicRendererComponent(SliderRendererComponent);
        this.rendererComponent.data = this.section.sliderOptions;
        if(this.currentComponent != undefined){
          this.currentComponent = this.rendererComponent.component;
          this.loadComponent(this.currentComponent);
        }else{
          this.currentComponent = this.rendererComponent.component;
        }
        break; */
      /* case "newsletter-sign-up":
        this.section = new KwikstoreSection<NewsLetterSignUp>();
        this.section.heading = this.sectionData.heading;
        this.section.newsLetterOptions = this.sectionData;
        this.rendererComponent = new DynamicRendererComponent(NewsletterSignupRendererComponent);
        this.rendererComponent.data = this.section.newsLetterOptions;
        if(this.currentComponent != undefined){
          this.currentComponent = this.rendererComponent.component;
          this.loadComponent(this.currentComponent);
        }else{
          this.currentComponent = this.rendererComponent.component;
        }
        break;
      case "store-features":
        this.section = new KwikstoreSection<StoreFeatures>()
        this.section.heading = this.sectionData.heading;
        this.rendererComponent = new DynamicRendererComponent(StoreFeatureRendererComponent);
        this.rendererComponent.data = this.sectionData;
        if(this.currentComponent != undefined){
          this.currentComponent = this.rendererComponent.component;
          this.loadComponent(this.currentComponent);
        }else{
          this.currentComponent = this.rendererComponent.component;
        }
        break;
      case "rich-text":
        this.section = new KwikstoreSection<RichTextBlock>()
        this.section.heading = this.sectionData.heading;
        this.rendererComponent = new DynamicRendererComponent(RichTextRendererComponent);
        this.rendererComponent.data = this.sectionData;
        if(this.currentComponent != undefined){
          this.currentComponent = this.rendererComponent.component;
          this.loadComponent(this.currentComponent);
        }else{
          this.currentComponent = this.rendererComponent.component;
        }
        break */;
      case "testimonials":
        this.rendererComponent = new DynamicRendererComponent(TestimonialRendererComponent, this.section.sectionData);
        break;
      case "category":
        this.rendererComponent = new DynamicRendererComponent(CategoryRendererComponent, this.section.sectionData)
        break;
      default:
        break;
    }
  }

  loadComponent(currentComponent: any) {
    const viewContainerRef = this.kveRenderCell?.viewContainerRef;
    if (viewContainerRef != undefined) {
      viewContainerRef.clear();
      console.log(this.rendererComponent.data)
      const componentRef = viewContainerRef.createComponent(currentComponent);
      (<RendererDataInterFace>componentRef.instance).data = this.rendererComponent.data;
      (<RendererDataInterFace>componentRef.instance).preview = true;
      componentRef.changeDetectorRef.detectChanges();
      (<RendererDataInterFace>componentRef.instance).editUpdate.subscribe(data => {
        console.log(data);
      })
      if (currentComponent instanceof BannerRendererComponent) {
        currentComponent.editUpdate.subscribe(data => console.log(data))
      }
    }

  }

  ngAfterViewInit(): void {
    // Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    // Add 'implements AfterViewInit' to the class.
    this.themeEditorStoreService.state$.subscribe(themeConfig => {
      this.kveThemeClass = themeConfig.themeConfigState.name;
      setTimeout(() => {
        const previewHostEl: HTMLElement = this.previewHost.elementRef.nativeElement;
        previewHostEl.classList.add("nb-theme-" + this.kveThemeClass)
      }, 100);
    });
    if (this.rendererComponent != undefined) {
      setTimeout(() => {
        this.loadComponent(this.rendererComponent.component);
      }, 100)
    }
    const hostEl = <HTMLElement>this.kveRenderCell.viewContainerRef.element.nativeElement;
    if (hostEl != null) {
      const parent = hostEl.parentElement;
      if (parent != null) {
        const hrefs = parent.getElementsByTagName("A");
        // console.log(parent)
        console.log(hrefs)
        if (hrefs.length > 0) {
          for (let i = 0; i < hrefs.length; i++) {
            const el = <HTMLElement>hrefs[i];
            el.removeAttribute("href");
            el.setAttribute("role", "link");
            el.setAttribute("aria-disabled", "true");
          }
        }
      }
    }

    // console.log(hostEl.querySelectorAll('grid-cell-container').length);
    console.log(this.previewHost.elementRef.nativeElement);
  }

  refreshPreview() {
    console.log("RefreshView")
    /* this.cellEditorStoreService.selectedCell$.subscribe((_selectedCell: GridCell | RowCell) => {
      this.selectedCell = _selectedCell;
      this.loadComponent(this.rendererComponent.component);
    }) */
  }
  /* preventLinking(e:PointerEvent){
  console.log(e.type);
  let target = e.target as HTMLElement;
    if (target.tagName.toLowerCase() === "a" && target !== undefined) {
      console.log("stopPropagation ....")

      e.stopPropagation();
    }
  } */

  onLoad() {
    const responsiveConf = { section: this.section, rendererType: this.rendererType, selectedCell: this.selectedCell };
    this.responsiveView.emit(responsiveConf);
  }

  updateSection(selectedCell): Section {
    let sectionData = this.section.sectionData;
    let optionType: string;
    let cells: RowCell[] | GridCell[];
    switch (this.rendererType) {
      case "grid":
      case "GRID":
      case "RendererType.GRID":
        cells = this.section.sectionData.gridOptions.gridCells;
        optionType = "gridOptions"
        // this.loadComponent(this.currentComponent);
        // console.log({Section:this.section});
        // console.log(this.rendererComponent);
        break;
      case "row":
      case "RendererType.ROW":
        cells = sectionData.rowOptions.rowCells;
        optionType = "rowOptions"
        break;
      case "banner":
      case "RendererType.BANNER":
        cells = sectionData.bannerOptions.gridCells
        optionType = "bannerOptions"
        break;
      case "bloglist":
      case "RendererType.BLOGLIST":
        cells = sectionData.rowOptions.rowCells;
        optionType = "rowOptions"
        break;
      case "slider":
        console.log("Its a slider")
        cells = sectionData.rowOptions.rowCells;
        optionType = "rowOptions"
        break;
      case "newsletter-sign-up":
        cells = sectionData.rowOptions.rowCells;
        optionType = "rowOptions"
        break;
      case "store-features":
        cells = sectionData.rowOptions.rowCells;
        optionType = "rowOptions"
        break;
      case "rich-text":
      case "RendererType.RICH_TEXT":
        cells = sectionData.rowOptions.rowCells;
        optionType = "rowOptions"
        break;
      case "testimonials":
        cells = sectionData.rowOptions.rowCells;
        optionType = "rowOptions"
        break;
      case "category":
      case "RendererType.CATEGORY":
        cells = sectionData.rowOptions.rowCells;
        optionType = "rowOptions"
        break
      case "product":
      case "RendererType.PRODUCT":
        cells = sectionData.rowOptions.rowCells;
        optionType = "rowOptions"
        break
      case "cart":
      case "RendererType.CART":
        cells = sectionData.rowOptions.rowCells;
        optionType = "rowOptions"
        break
      case "blog":
      case "RendererType.BLOG":
        cells = sectionData.rowOptions.rowCells;
        optionType = "rowOptions"
        break
      case "hero-image":
      case "RendererType.HEROIMAGE":
        cells = sectionData.rowOptions.rowCells;
        optionType = "rowOptions"
        break
      default:
        break;
    }
    // Find the selectedCell by cellId
    const cellToUpdate = cells.find(cell => cell.cellId === selectedCell.cellId)
    if (cellToUpdate) {
      console.log(cellToUpdate)
      // cellToUpdate = selectedCell
      // cells = [...cells,cellToUpdate]
      Object.assign(cellToUpdate, selectedCell);
      console.log(cells)
      // Update the sectionData
      sectionData = this.updateSectionData(cells, optionType);

    }
    this.section = { ...this.section, sectionData }
    return this.section
  }

  updateSectionData(cells, optionType): SectionData {
    let sectionData = this.section.sectionData;
    // gridOptions,rowOptions,bannerOptions
    switch (optionType) {
      case "gridOptions":
        let gridOptions = sectionData.gridOptions;
        gridOptions = { ...gridOptions, gridCells: cells }
        sectionData = { ...sectionData, gridOptions }
        break;
      case "rowOptions":
        let rowOptions = sectionData.rowOptions;
        rowOptions = { ...rowOptions, rowCells: cells }
        sectionData = { ...sectionData, rowOptions }
        break;
      case "bannerOptions":
        let bannerOptions = sectionData.bannerOptions;
        bannerOptions = { ...bannerOptions, gridCells: cells }
        sectionData = { ...sectionData, bannerOptions }
        break;
    }
    return sectionData
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }


}
